<main class="nw-container">
    <nav aria-label="Bread Crumb Navigation">
        <bolt-breadcrumbs class="bolt-space-bottom-sm" currentleveltext="{{currentPage}}" iconlink="{{homeIconLink}}">
            <li *ngFor="let bc of breadCrumbs">
                    <a [routerLink]="bc.link">{{bc.name}}</a>
                </li>
        </bolt-breadcrumbs>
    </nav>
    <h1 id="gettingStartedHeader" class="text margin-top-20">
        <p>
            <span>Let's get started.</span>
        </p>
    </h1>
    <is-what-you-can-expect [lineOfBusiness]="lineOfBusiness"></is-what-you-can-expect>
    <div class="row form-group">
        <div class="col-sm-7 col-md-7 col-lg-5">
            <p>All fields are required unless otherwise noted.</p>
            <div id="secureTransactionSection" class="header-icon before-sprite">
                <img src="assets/images/icons-svg/new-lock.svg" [width]="30" [height]="30" alt="secure lock">
                <a href="https://www.nationwide.com/privacy-security.jsp" target="_blank">
                    <span style="text-decoration: underline;">Secure Transaction</span>
                </a>
            </div>
        </div>
    </div>
    <div class="bolt-space-bottom-sm" >
        <form [formGroup]="fnolForm" (ngSubmit)="submitForm()">
            <div class="page-header">
                <h2 id="contactInformationHeader">Contact Information</h2>
            </div>
            <div class="row form-group">
                <div class="col-sm-7 col-md-7 col-lg-5">
                    <label for="insuredName">Insured name</label>
                    <span id="insuredName">{{namedInsured}}</span>
                </div>
            </div>
            <div class="row form-group">
                <div class="col-sm-7 col-md-7 col-lg-5">
                    <label class="inline" for="submitterFirstName">Submitter's first name</label>
                    <input type="text" class="form-control" id="submitterFirstName" name="firstName" [formControl]="submitterFirstName" aria-required="true" aria-describedby="submitterFirstName"
                        [ngClass]="{'has-error':(submitterFirstName.invalid && submitterFirstName.touched)}">
                    <div *ngIf="submitterFirstName.invalid && submitterFirstName.touched" class="alert alert-danger nw-field-error" id="submitterFirstNameErrorId">
                        <span *ngIf="submitterFirstName.hasError('required')" id="submitterFirstNameErrorMessage">Required</span>
                        <span *ngIf="submitterFirstName.hasError('pattern')" id="submitterFirstNameErrorMessage">Submitter's
                            first name is invalid</span>
                    </div>
                </div>
            </div>
            <div class="row form-group">
                <div class="col-sm-7 col-md-7 col-lg-5">
                    <label for="submitterLastName">Submitter's last name</label>
                    <input type="text" class="form-control" id="submitterLastName" name="lastName" [formControl]="submitterLastName" aria-required="true" aria-describedby="submitterLastName"
                        [ngClass]="{'has-error':(submitterLastName.invalid && submitterLastName.touched)}">
                    <div *ngIf="submitterLastName.invalid && submitterLastName.touched" class="alert alert-danger nw-field-error" id="submitterLastNameErrorId">
                        <span *ngIf="submitterLastName.hasError('required')" id="submitterLastNameErrorMessage">Required</span>
                        <span *ngIf="submitterLastName.hasError('pattern')" id="submitterLastNameErrorMessage">Submitter's
                            last
                            name is invalid</span>
                    </div>
                </div>
            </div>
            <div class="row form-group">
                <div class="col-sm-7 col-md-7 col-lg-5">
                    <label for="contactPhoneNumber">
                        Best number to call</label>
                    <input type="text" class="form-control" id="contactPhoneNumber" name="phoneNumber" [formControl]="contactPhoneNumber" aria-required="true" aria-describedby="contactPhoneNumber"
                        placeholder="555-555-5555" [ngClass]="{'has-error':(contactPhoneNumber.invalid && contactPhoneNumber.touched)}">
                    <div *ngIf="contactPhoneNumber.invalid && contactPhoneNumber.touched" class="alert alert-danger nw-field-error" id="contactPhoneNumberErrorId">
                        <span *ngIf="contactPhoneNumber.hasError('required')" id="contactPhoneNumberErrorMessage">Required</span>
                        <span *ngIf="contactPhoneNumber.hasError('pattern')" id="contactPhoneNumberErrorMessage">Best number
                            to call is invalid</span>
                    </div>
                </div>
            </div>
            <div id="phoneNumberTypes" class="row form-group">
                <div class="col-sm-7 col-md-7 col-lg-5">
                    <fieldset>
                        <legend for="phoneTypes">Phone type</legend>
                        <div style="position: relative;" class="btn-group" data-toggle="buttons" id="phoneTypes">
                            <label class="btn btn-default form-check-label" [ngClass]="{'active':(submitterPhoneType.value ==='Cell')}" for="phoneTypeCell">
                                <input name="submitterPhoneType" class="form-check-input" type="radio" checked="submitterPhoneType.value ==='Cell'" autocomplete="off" value="Cell"
                                    [formControl]="submitterPhoneType" id="phoneTypeCell">Cell
                            </label>
                            <label class="btn btn-default form-check-label" [ngClass]="{'active':(submitterPhoneType.value ==='Business')}" for="phoneTypeBusiness">
                                <input name="submitterPhoneType" class="form-check-input" type="radio" checked="submitterPhoneType.value ==='Business'" autocomplete="off" value="Business"
                                    [formControl]="submitterPhoneType" id="phoneTypeBusiness">Business
                            </label>
                            <label class="btn btn-default form-check-label" [ngClass]="{'active':(submitterPhoneType.value ==='Home')}" for="phoneTypeHome">
                                <input name="submitterPhoneType" class="form-check-input" type="radio" checked="submitterPhoneType.value ==='Home'" autocomplete="off" value="Home"
                                    [formControl]="submitterPhoneType" id="phoneTypeHome">Home
                            </label>
                        </div>
                        <div *ngIf="submitterPhoneType.invalid && submitterPhoneType.touched" class="alert alert-danger nw-field-error" id="submitterPhoneTypeErrorId">
                            <span *ngIf="submitterPhoneType.hasError('required')" id="submitterPhoneTypeErrorMessage">Required</span>
                        </div>
                    </fieldset>
                </div>
            </div>
            <div id="cellDisclaimerText" *ngIf="submitterPhoneType.value ==='Cell'" class="row form-group">
                <div class="col-sm-7 col-md-7 col-lg-5">
                    <em>
                        <span class="block full-width margin-top-5">
                            You authorize the Nationwide Family of Companies and its agents to use this cell phone number
                            for general servicing purposes
                            (e.g. policy or account management, fraud prevention, reminders) using any of the following:
                            live
                            operators, automated telephone dialing systems, or pre-recorded messages.</span>
                    </em>
                </div>
            </div>
            <div id="submitterRecieveText" *ngIf="submitterPhoneType.value ==='Cell' && lineOfBusiness === 'Commercial Auto'" class="row form-group">
                <div class="col-sm-7 col-md-7 col-lg-5">
                    <label for="recieveTextYesNo">Would you like to receive text alerts that contain basic information about
                        your claim?</label>
                    <div>
                        <div class="btn-group" data-toggle="buttons" id="recieveTextYesNo">
                            <label class="btn btn-default form-check-label" [ngClass]="{'active':(submitterRecieveText.value ==='Yes')}">
                                <input name="submitterRecieveText" class="form-check-input" type="radio" checked="submitterRecieveText.value ==='Yes'" autocomplete="off" value="Yes"
                                    [formControl]="submitterRecieveText">Yes
                            </label>
                            <label class="btn btn-default form-check-label" [ngClass]="{'active':(submitterRecieveText.value ==='No')}">
                                <input name="submitterRecieveText" class="form-check-input" type="radio" checked="submitterRecieveText.value ==='No'" autocomplete="off" value="No"
                                    [formControl]="submitterRecieveText">No
                            </label>
                        </div>
                        <div *ngIf="submitterRecieveText.invalid && submitterRecieveText.touched" class="alert alert-danger nw-field-error" id="submitterRecieveTextErrorId">
                            <span *ngIf="submitterRecieveText.hasError('required')" id="submitterRecieveTextErrorMessage">Required</span>
                        </div>
                    </div>
                </div>
            </div>
            <div id="cellDisclaimerText2" *ngIf="submitterPhoneType.value ==='Cell' && lineOfBusiness === 'Commercial Auto'" class="row form-group">
                <div class="col-sm-7 col-md-7 col-lg-5">
                    <em>
                        <small class="block full-width margin-top-5">
                            Once you receive the initial text, please reply "Yes" within two hours to opt in to receiving
                            texts. Multiple messages may
                            be received. Data and message rates may apply.</small>
                    </em>
                </div>
            </div>
            <div class="row form-group">
                <div class="col-sm-7 col-md-7 col-lg-5">
                    <label for="submitterEmail">Submitter's email</label>
                    <input type="text" class="form-control" id="submitterEmail" name="submitterEmail" [formControl]="submitterEmail" aria-required="true" aria-describedby="submitterEmail"
                        placeholder="name@domain.com" [ngClass]="{'has-error':(submitterEmail.invalid && submitterEmail.touched)}">
                    <div *ngIf="submitterEmail.invalid && submitterEmail.touched" class="alert alert-danger nw-field-error" id="submitterEmailErrorId">
                        <span *ngIf="submitterEmail.hasError('required')" id="submitterEmailErrorMessage">Required</span>
                        <span *ngIf="submitterEmail.hasError('pattern')" id="submitterEmailErrorMessage">Submitter's email
                            is
                            invalid
                        </span>
                    </div>
                </div>
            </div>
            <div class="row form-group">
                <div class="col-sm-7 col-md-7 col-lg-5">
                    <label for="dateOfIncident">Date of incident</label>
                    <input type="date" id="dateOfIncident" class="form-control" aria-required="true" aria-describedby="dateOfIncident" [formControl]="dateOfIncident" [max]="maxDate" maxlength="10"
                        [ngClass]="{'has-error':(dateOfIncident.invalid && dateOfIncident.touched)}" placeholder="mm/dd/yyyy" />
                    <div *ngIf="dateOfIncident.invalid && dateOfIncident.touched" class="alert alert-danger nw-field-error" id="dateOfIncidentErrorId">
                        <span *ngIf="dateOfIncident.hasError('required')" id="dateOfIncidentErrorMessage">Required</span>
                        <span *ngIf="dateOfIncident.hasError('pattern')" id="dateOfIncidentErrorMessage">Date of incident is
                            invalid
                        </span>
                    </div>
                </div>
            </div>
            <div id="timeOfIncident" class="row form-group">
                <div class="col-sm-7 col-md-7 col-lg-5">
                    <fieldset>
                        <legend for="incidentHour">Time of incident</legend>
                        <div [ngClass]="{'has-error':( incidentHour.touched && incidentHour.invalid)}" class="inline">
                            <select class="form-control" name="hour" [formControl]="incidentHour" id="incidentHour" aria-label="time of incident hour">
                                <option value="" selected>Hour</option>
                                <option *ngFor="let hour of hours">{{hour}}</option>
                            </select>
                            <div *ngIf="incidentHour.touched && incidentHour.invalid" class="alert alert-danger nw-field-error" id="accountNumberRequiredErrorId">
                                <span id="timeOfIncidentHourRequiredErrorMessage">Required</span>
                            </div>
                        </div>
                        <div [ngClass]="{'has-error':(incidentMinute.touched && incidentMinute.invalid)}" class="inline">
                            <select class="form-control" name="minute" [formControl]="incidentMinute" id="incidentMinute" aria-label="time of incident minute">
                                <option value="" selected>Minutes</option>
                                <option *ngFor="let minute of minutes">{{minute}}</option>
                            </select>
                            <div *ngIf="incidentMinute.touched && incidentMinute.invalid" class="alert alert-danger nw-field-error" id="timeOfIncidenMinuteRequiredErrorId">
                                <span id="timeOfIncidenMinuteRequiredErrorMessage">Required</span>
                            </div>
                        </div>
                        <div class="btn-group inline" data-toggle="buttons" id="timeOfIncidentGroup">
                            <label class="btn btn-default form-check-label" [ngClass]="{'active':(incidentMeridiem.value ==='AM')}">
                                <input class="form-check-input" type="radio" checked="incidentMeridiem.value ==='AM'" autocomplete="off" value="AM" formControlName="incidentMeridiem">AM
                            </label>
                            <label class="btn btn-default form-check-label" [ngClass]="{'active':(incidentMeridiem.value ==='PM')}">
                                <input class="form-check-input" type="radio" checked="incidentMeridiem.value ==='PM'" autocomplete="off" value="PM" formControlName="incidentMeridiem">PM
                            </label>
                        </div>
                    </fieldset>
                </div>
            </div>
            <is-address [parentForm]="fnolForm" [fieldNameSpace]="'incidentLocation'" [addressHeader]="'Incident Location'" [lineOfBusiness]="lineOfBusiness"></is-address>
            <div class="row form-group">
                <div class="col-sm-7 col-md-7 col-lg-5">
                    <label for="description">Describe what happened</label>
                    <small class="form-text text-muted">Remaining characters:
                        <strong>{{descriptionMaxLength - description.value.length}}</strong>
                    </small>
                    <textarea type="textarea" class="form-control" id="description" name="description" aria-required="true" aria-describedby="description" [maxLength]="descriptionMaxLength" rows="8"
                        formControlName="description" [ngClass]="{'has-error':(description.invalid && description.touched)}"></textarea>
                    <div *ngIf="description.invalid && description.touched" class="alert alert-danger nw-field-error" id="descriptionErrorId">
                        <span *ngIf="description.hasError('required')" id="descriptionErrorMessage">Required</span>
                    </div>
                </div>
            </div>

            <is-general-liability [fnolForm]="fnolForm" *ngIf="lineOfBusiness === 'General Liability'">
            </is-general-liability>
            <is-workers-compensation [fnolForm]="fnolForm" *ngIf="lineOfBusiness === 'Workers Compensation'">
            </is-workers-compensation>
            <is-business-auto [fnolForm]="fnolForm" [incidentLocationState]="incidentLocationState" *ngIf="lineOfBusiness === 'Commercial Auto'"></is-business-auto>
            <is-commercial-property [fnolForm]="fnolForm" *ngIf="lineOfBusiness === 'Commercial Property'">
            </is-commercial-property>
            <is-fraud-language [state]="state" [lineOfBusiness]="lineOfBusiness"></is-fraud-language>
            <div class="nw-button-container nw-bg-light-blue">
                <button id="continueButton" class="btn btn-primary pull-right" type="submit">Submit</button>
                <button class="btn btn-default pull-left" id="cancelButton" type="button" (click)="cancelClaim()">Cancel</button>
            </div>
        </form>
    </div>
    <nav aria-label="Bread Crumb Navigation">
        <bolt-breadcrumbs class="bolt-space-bottom-sm" currentleveltext="{{currentPage}}" iconlink="{{homeIconLink}}">
            <li *ngFor="let bc of breadCrumbs">
                    <a [routerLink]="bc.link">{{bc.name}}</a>
                </li>
        </bolt-breadcrumbs>
    </nav>
</main>
